import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { InfosPopupModal } from '../InfosPopupModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var InfosPopup = function InfosPopup(_ref) {
  var builders = _ref.builders,
    sellers = _ref.sellers,
    httpApi = _ref.httpApi,
    logger = _ref.logger,
    _ref$multiplePhoneBut = _ref.multiplePhoneButtonText,
    multiplePhoneButtonText = _ref$multiplePhoneBut === void 0 ? 'Показать контакты' : _ref$multiplePhoneBut,
    pageType = _ref.pageType,
    platformType = _ref.platformType,
    placeType = _ref.placeType,
    onModalOpen = _ref.onModalOpen,
    onPhoneOpen = _ref.onPhoneOpen,
    _ref$openContactsStyl = _ref.openContactsStyles,
    openContactsStyles = _ref$openContactsStyl === void 0 ? {} : _ref$openContactsStyl,
    openContactsSellerPhoneStyles = _ref.openContactsSellerPhoneStyles,
    openContactsBuilderPhoneStyles = _ref.openContactsBuilderPhoneStyles,
    phoneButtonTestId = _ref.phoneButtonTestId;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setModalOpen = _React$useState2[1];
  var onClick = function onClick() {
    setModalOpen(true);
    /* istanbul ignore else */
    if (onModalOpen) {
      onModalOpen();
    }
  };
  var onClose = React.useCallback(function () {
    return setModalOpen(false);
  }, [setModalOpen]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(InfosPopupModal, {
      open: open,
      httpApi: httpApi,
      logger: logger,
      pageType: pageType,
      platformType: platformType,
      placeType: placeType,
      builders: builders,
      sellers: sellers,
      onPhoneOpen: onPhoneOpen,
      openContactsSellerPhoneStyles: openContactsSellerPhoneStyles,
      openContactsBuilderPhoneStyles: openContactsBuilderPhoneStyles,
      onClose: onClose,
      phoneButtonTestId: "PhoneButton"
    }), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      "data-testid": phoneButtonTestId
    }, openContactsStyles), {}, {
      onClick: onClick,
      children: multiplePhoneButtonText
    }))]
  });
};